import React, { useContext } from 'react';
import { I18nProviderContext } from 'contexts/I18nProvider';
import { Container } from './Header.styles';

export const Header = () => {
	const { translate } = useContext(I18nProviderContext);

	return (
		<Container>
			{translate('views.campaigns.evaluations.cards.header.title')}
		</Container>
	);
};
